import { useLazyQuery, useMutation } from "@apollo/client";
import { useEffect, useRef, useState } from "react";
import { RiErrorWarningFill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";

import useSubmitOperation, {
  getMutationFunction,
  handleFormSubmission,
  usePrepareGraphQLVariables,
} from "../../../../../CommonFunction/CustomUseFormSubmission";
import { ClearSpecificForm } from "../../../../../Store/FormDataReducer/FormFieldFunctions";
import {
  AccountsForTax,
  CreateTax,
  Delete_Sales_Expense_formula,
  editTax,
  get_Tax_By_Id,
} from "../../../../../Utils/AllPagesQuriesAndMutations";
import { checkFormErrors } from "../../../../custom_hooks/useCheckFormError";
import useConcatenatedString from "../../../../custom_hooks/useConcatenatedString";
import useFetchFormFields from "../../../../custom_hooks/useFetchFormFields";
import { FormInputSectionComponent } from "../../../FormInputSectionComponent/FormInputSectionComponent";
import { handleFormReset, updateSingleField, updateValueForm } from "../../../FormInputSectionComponent/formUtils";
import { useModalContext } from "../../../Reactportal/ModalContext";
import PortalFooter from "../../../Reactportal/PortalFooter";
import Reactportal from "../../../Reactportal/Reactportal";
import { ErrorToast } from "../../../ToastComponent/RectHotToast";
import "../.././FormComponent.scss";
import { data } from "./AddTax.config";
import "./AddTax.scss";


const AddTax = ({ show, id, TypeOfPortal, submitType, ParentPortalCloseFunction }) => {
  const modifiedTypeOfPortal = useConcatenatedString(TypeOfPortal, "Sales Expense Formula");
  const Form_Key = "Tax";
  const formRef = useRef({});
  const { pushModal, popModal } = useModalContext();
  const [toggle, settoggle] = useState(show ? show : false);
  const fielddataRedux = useSelector((store) => store.UniqueTableReducer);
  const fielddata = fielddataRedux?.Tax?.Selected_Row;
  const [allFieldsData, setAllFieldsData] = useState();
  const [selectedRows, setSelectedRows] = useState([]);
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);
  const dispatch = useDispatch();
  const [isFirstLoad, setFirstLoad] = useState(false)
  const [FormData, setFormdata] = useState({});
  const [formErrors, setFormErrors] = useState({});

  //Q & M

  const [GetAccountsForTax] = useLazyQuery(AccountsForTax)
  const {
    loading: getFormFieldsLoading,
    data: inputFields,
    getFormSectionAndFields,
  } = useFetchFormFields({ Form_Key });

  const [CreatingData, { loading: createSalesFormulaLoading }] = useMutation(CreateTax);

  const [getTaxById, { loading: GetSalesFormulaIDSLoader }] = useLazyQuery(get_Tax_By_Id, {
    fetchPolicy: "network-only",
  });

  const [EditingData, { loading: eidtSalesFormulaLoading }] = useMutation(editTax, {
    fetchPolicy: "network-only",
  });

  const [DeletingData, { loading: DeleteSalesExpenseFormulaLoading }] = useMutation(Delete_Sales_Expense_formula);

  const SalesExpenseFormulaLoadingState =
    DeleteSalesExpenseFormulaLoading ||
    eidtSalesFormulaLoading ||
    createSalesFormulaLoading ||
    GetSalesFormulaIDSLoader ||
    getFormFieldsLoading;

  useEffect(() => {
    setSelectedRows(fielddataRedux?.Sales_Expense_Formula?.Selected_Rows);
  }, [fielddataRedux]);

  const HanldeChangeonForm = (values) => {
    setFormdata((prev) => ({
      ...prev,
      ...values,
    }));
  };

  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };

  useEffect(() => {
    if (TypeOfPortal !== "Add") {
      getFormSectionAndFields().then(() => {
        getTaxById({
          variables: {
            id: fielddata?._id,
          },
        }).then(({ data }) => {
          let TaxData = { ...data?.getTaxByID };
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: Form_Key,
              data: {
                Tax_Rate: {
                  ...TaxData.Tax_Rate,
                  Search_Value: TaxData.Tax_Rate?.Tax_Percentage,
                },
                Input_Account: { ...TaxData.Input_Account, Account_Balance_Id: TaxData.Input_Account?._id }
                , Output_Account: { ...TaxData.Output_Account, Account_Balance_Id: TaxData.Output_Account?._id }
              },
            },
          });
          if (TaxData && TaxData.Input_Account) {
            TaxData.Input_Account = TaxData?.Input_Account?.Search_Value;
          }
          if (TaxData && TaxData.Tax_Rate) {
            TaxData.Tax_Rate = TaxData?.Tax_Rate?.Tax_Percentage;
          }
          if (TaxData && TaxData.Output_Account) {
            TaxData.Output_Account = TaxData?.Output_Account?.Search_Value;
          }
          setAllFieldsData(TaxData);
          updateValueForm(formRef, TaxData);
        });
      });
    }
  }, [fielddata]);

  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key);
    };
  }, []);
  useEffect(() => {
    if (FormData?.Tax_Type && isFirstLoad) {
      GetAccountsForTax({
        variables: {
          taxType: FormData.Tax_Type
        }
      }).then(({ data }) => {
        console.log(data?.accountsForTaxByTaxType)
        updateSingleField(formRef, "Input_Account", data?.accountsForTaxByTaxType?.Input?.Search_Value)
        updateSingleField(formRef, "Output_Account", data?.accountsForTaxByTaxType?.Output?.Search_Value)
        dispatch({
          type: "StoreMasterData",
          payload: {
            formkey: Form_Key,
            data: {
              Input_Account: data?.accountsForTaxByTaxType?.Input
              , Output_Account: data?.accountsForTaxByTaxType?.Output
            },
          },
        });
      })
    }
  }, [FormData?.Tax_Type])

  const { executeOperation } = useSubmitOperation();
  const operationType = TypeOfPortal;
  let formData = FormData;
  const variables = usePrepareGraphQLVariables(operationType, allFieldsData, formData, selectedRows);
  const BranchMutations = {
    CreatingData,
    EditingData,
    DeletingData,
  };

  const submit = async (closeAction) => {
    formData.Tax_Rate = FormDataFromRedux?.MasterData[Form_Key]?.Tax_Rate?._id;
    formData.Input_Account = FormDataFromRedux?.MasterData[Form_Key]?.Input_Account?.Account_Balance_Id;
    formData.Output_Account = FormDataFromRedux?.MasterData[Form_Key]?.Output_Account?.Account_Balance_Id;
    formData = {
      AccountName: formData.Expense_Account,
    };
    const mutationFunction = getMutationFunction(operationType, BranchMutations);
    const executeOperationFunction = () =>
      executeOperation({
        operationType,
        data: formData,
        selectedRows,
        Mutation: () => mutationFunction({ variables }),
        processDataBeforeSubmit: (data) => data,
        PageName: Form_Key,
        OnSuccess: (res) => {
          handleFormReset(formRef);
        },
      });
    handleFormSubmission(executeOperationFunction, {
      dispatch,
      operationType,
      closeAction,
      closeFormFunction: Closeformfunction,
      resetFormDataFunction: () => {
        setAllFieldsData();
        handleFormReset(formRef);
      },
      onSuccess: () => { },
      onError: (error) => {
        ErrorToast(error.message);
      },
    });
  };

  const Closeformfunction = () => {
    ClearSpecificForm(dispatch, Form_Key);
    ParentPortalCloseFunction();
    settoggle(false);
  };

  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);
    if (!Error) {
      submit();
    }
  };

  const SaveAndCloseForAdd = () => {
    submit("Close");
  };

  if (TypeOfPortal === "Delete") {
    return (
      <Reactportal open={toggle} onClose={() => settoggle(false)} TypeOfPortal={"Confirm"}>
        <div className="warning">
          <RiErrorWarningFill className="warningIcon" />
          <p className="warningMsg">Are You Sure You Want to Delete this Record?</p>
        </div>

        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitform={submit}
          submitType={"Confirm Delete"}
          handleformclose={() => {
            settoggle(!toggle);
          }}
          loadingState={SalesExpenseFormulaLoadingState}
        />
      </Reactportal>
    );
  }

  const footerContent = (
    <PortalFooter
      renderContent={() => <></>}
      disabled={false}
      submitform={submit}
      submitType={submitType}
      Form_key={Form_Key}
      TypeOfPortal={TypeOfPortal}
      SaveAndClose={SaveAndCloseForAdd}
      handleformclose={() => {
        Closeformfunction();
        settoggle(!toggle);
      }}
      loadingState={SalesExpenseFormulaLoadingState}
    />
  );

  return (
    <div>
      <Reactportal
        FoooterContent={footerContent}
        open={toggle}
        onClose={Closeformfunction}
        TypeOfPortal={TypeOfPortal + " " + "Tax"}
        TypeOfId={"Account Id :"}
      >
        {SalesExpenseFormulaLoadingState && <div className="loader-line-div" />}
        <div className="SalesContainerr">
          <div className="SalesExpenseFormulaContainer">
            {inputFields?.length > 0 ? (
              inputFields.map((e) => (
                <FormInputSectionComponent
                  key={e.id}
                  inputfields={e.fields}
                  Type={e.name}
                  fielddata={allFieldsData}
                  TypeOfPortal={modifiedTypeOfPortal}
                  configData={data}
                  onErrorsChange={handleErrorsChange}
                  onhandleFormikChange={HanldeChangeonForm}
                  formkey={Form_Key}
                  formRef={formRef}
                  setFirstLoad={setFirstLoad}
                />
              ))
            ) : !getFormFieldsLoading && (inputFields?.message || inputFields?.length === 0) ? (
              <p>No form fields available.</p>
            ) : null}
          </div>
        </div>
      </Reactportal>
    </div>
  );
};

export default AddTax;
